import ErrorSymbol from "../assets/error-symbol.svg";
import { t } from "../i18n";
export default function (props: { error: any; onBack: () => void }) {
  console.log("error :: ", props.error);
  return (
    <section class="flex flex-col w-40% h-full self-center text-center items-center justify-center">
      <div class="flex flex-col items-center justify-center">
        <ErrorSymbol />
        <span class="text-16px text-text-alt">{t().page_not_found.error}</span>
        <p class="text-40px font-bold">{t().page_not_found.title}</p>
        <p class="text-20px">{props?.error ?? t().page_not_found.subtitle}</p>
        <p
          //
          class="bg-text text-16px rounded-md text-bg py-2 px-4 mt-2 cursor-pointer"
          onclick={() => {
            props.onBack?.();
          }}
        >
          {t().page_not_found.back}
        </p>
      </div>
    </section>
  );
}
